import { render } from "./editInserat.vue?vue&type=template&id=1d6a5804&scoped=true"
import script from "./editInserat.vue?vue&type=script&lang=ts"
export * from "./editInserat.vue?vue&type=script&lang=ts"

import "./editInserat.vue?vue&type=style&index=0&id=1d6a5804&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d6a5804"

export default script